import {Loading as LoadingIcon} from "components/helpers";

export default function Loading() {
  return (
    <div className="container-fluid">
      <LoadingIcon />
    </div>
  );
}
